import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reg-bhmsdemo',
  templateUrl: './reg-bhmsdemo.component.html',
  styleUrls: ['./reg-bhmsdemo.component.scss']
})
export class RegBHMSdemoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
